export const VERSION = "1.2.1";
// export const API_URL = "http://192.168.0.12:8200/api/v1";
export const API_URL = "http://aliados.refacil.co/api/v1";

export default API_URL;
